import * as React from 'react'
import PropTypes from 'prop-types'
import { StyledHeaderMenuList } from './style'

const HeaderMenuList = ({ children, inDropdown, ...rest }) => (
  <StyledHeaderMenuList inDropdown={inDropdown} {...rest}>
    {children}
  </StyledHeaderMenuList>
)

HeaderMenuList.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired,
  inDropdown: PropTypes.bool,
}

HeaderMenuList.defaultProps = {
  inDropdown: false,
}

export default HeaderMenuList
